export class UnitaryPatentConstants {
  public static validationRules: {
    required: (value: any) => boolean | string,
    emailFormat: (values: any) => boolean | string
  } = {
    required: v =>  ((typeof(v) == "number") ? !!(v.toString()) : !!v) || "This field is required",
    emailFormat: (value: string) => !value || (!!value && UnitaryPatentConstants.emailFormat.test(value)) || 'Email address has an invalid format'
        }

    public static customerIdRules: {
        numberFormat: (values: any) => boolean | string
    } = {
            numberFormat: v => v != null ? UnitaryPatentConstants.numberFormat.test(v) || 'Must be number or must contain max 6 digits' : true,
        }

  // Regular expression for email format used in Savanta
    public static emailFormat: RegExp = /^(([a-zA-Z0-9&_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,}|[0-9]{1,3})(\]?)(\s*;\s*|\s*$))+$/;
    public static numberFormat: RegExp = /^[0-9]{0,6}$/;
    
}